(function(){
var PD=window.PRODUCT_DATA;
if(!PD)return;
var BLUE='#2563eb',GREEN='#1e3a5f';
var TRIMS=["None","Baby Threshold","Quarter Round","T-Mold","Overlap Stairnose","Reducer","Flush Stairnose","Round Stairtread","Square Stairtread"];
var SVCS=["New Flooring Installation","Demo / Remove Old Flooring","Baseboards & Trim","Subfloor Prep","Transitions & Moldings","Furniture Moving","Other"];
var RDCS=["ALBUQUERQUE RDC","BALTIMORE RDC","BOSTON RDC","CHARLOTTE RDC","CHICAGO RDC","CINCINNATI RDC","DALLAS RDC","DENVER RDC","DETROIT RDC","HOUSTON RDC","KANSAS CITY RDC","LAS VEGAS RDC","LOS ANGELES RDC","MEMPHIS RDC","MINNEAPOLIS RDC","NEW JERSEY RDC","OKLAHOMA CITY RDC","ORLANDO RDC","PHOENIX RDC","PITTSBURGH RDC","PORTLAND RDC","ST LOUIS RDC","SALT LAKE CITY RDC","SAN ANTONIO RDC","SAN FRANCISCO RDC","SAVANNAH RDC","SEATTLE RDC"];

var S={tab:'buy',bs:0,bv:null,bsq:'',btr:[],btq:'',btrQty:{},bsh:'pickup',brd:'',bad:'',bf:{},bd:false,es:0,ev:null,esq:'',etr:[],etq:'',etrQty:{},err:'',ecf:'',esv:[],edd:'',ef:{},ed:false};

function upP(o){
  Object.assign(S,o);
  if(o.bd===true)return submitPForm('buy');
  if(o.ed===true)return submitPForm('estimate');
  RP();
}
function upPQ(o){Object.assign(S,o);}

function submitPForm(type){
  var f,subj,body;
  var v=type==='buy'?S.bv:S.ev;
  if(type==='buy'){
    f=S.bf;
    subj='Buy Flooring Quote - '+PD.title;
    body='TYPE: Buy Flooring\n';
    body+='Product: '+PD.title+'\n';
    if(v)body+='Color: '+v+'\n';
    body+='Qty: '+S.bsq+' sqft\n';
    if(S.btr.length){var _tp=[];for(var _i=0;_i<S.btr.length;_i++){var _tn=S.btr[_i];var _tq=(S.btrQty&&S.btrQty[_tn])||1;_tp.push(_tn+' x'+_tq);}body+='Trim: '+_tp.join(', ')+'\n';}
    if(S.btq)body+='Trim Details: '+S.btq+'\n';
    body+='Shipping: '+(S.bsh==='pickup'?(S.brd||'Pick Up'):'Ship to address')+'\n';
    if(S.bad)body+='Address: '+S.bad+'\n';
  }else{
    f=S.ef;
    subj='Free Estimate - '+PD.title;
    body='TYPE: Free Estimate\n';
    body+='Product: '+PD.title+'\n';
    if(v)body+='Color: '+v+'\n';
    body+='Qty: '+S.esq+' sqft\n';
    if(S.etr.length){var _tp=[];for(var _i=0;_i<S.etr.length;_i++){var _tn=S.etr[_i];var _tq=(S.etrQty&&S.etrQty[_tn])||1;_tp.push(_tn+' x'+_tq);}body+='Trim: '+_tp.join(', ')+'\n';}
    if(S.etq)body+='Trim Details: '+S.etq+'\n';
    if(S.err)body+='Rooms: '+S.err+'\n';
    if(S.ecf)body+='Current Floor: '+S.ecf+'\n';
    if(S.esv.length)body+='Services: '+S.esv.join(', ')+'\n';
    if(S.edd)body+='Notes: '+S.edd+'\n';
    if(f.ad)body+='Address: '+f.ad+'\n';
    if(f.ct)body+='City: '+f.ct+'\n';
    if(f.st)body+='State: '+f.st+'\n';
    if(f.zp)body+='Zip: '+f.zp+'\n';
  }
  body+='Name: '+(f.fn||'')+' '+(f.ln||'')+'\n';
  body+='Email: '+(f.em||'')+'\n';
  body+='Phone: '+(f.ph||'')+'\n';
  body+='Source: Product Page - '+PD.handle+'\n';
  if(!f.fn||!f.ln||!f.em||!f.ph){alert('Please fill in all required fields.');if(type==='buy')S.bd=false;else S.ed=false;return RP();}
  var sfName=document.getElementById('gsp-cf-name');
  var sfEmail=document.getElementById('gsp-cf-email');
  var sfPhone=document.getElementById('gsp-cf-phone');
  var sfBody=document.getElementById('gsp-cf-body');
  if(!sfName||!sfEmail||!sfBody){console.log('GSP: Shopify form not found');alert('Form error - please call us instead.');if(type==='buy')S.bd=false;else S.ed=false;return RP();}
  sfName.value=(f.fn||'')+' '+(f.ln||'');
  sfEmail.value=f.em||'';
  sfPhone.value=f.ph||'';
  sfBody.value='['+subj+']\n\n'+body;
  try{sessionStorage.setItem('gsp_sent','1');sessionStorage.setItem('gsp_product',PD.title);}catch(e){}
  var frm=document.getElementById('gsp-shopify-form');
  if(frm){frm.submit();}
  RP();
}
function esc(s){if(!s)return '';var d=document.createElement('div');d.textContent=s;return d.innerHTML;}

function stH(ls,cur,col){
  var h='<div style="display:flex;align-items:center;justify-content:center;gap:6px;margin-bottom:28px">';
  for(var i=0;i<ls.length;i++){
    var bg=i<=cur?col:'#e5e5e5';
    var fg=i<=cur?'#fff':'#444';
    h+='<div style="display:flex;align-items:center;gap:6px"><div style="display:flex;flex-direction:column;align-items:center">';
    h+='<div style="width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;font-weight:700;background:'+bg+';color:'+fg+'">';
    h+=i<cur?'\u2713':String(i+1);
    h+='</div><div style="font-size:13px;color:#000;margin-top:3px;text-align:center;max-width:70px">'+esc(ls[i])+'</div></div>';
    if(i<ls.length-1)h+='<div style="width:24px;height:2px;margin-bottom:18px;background:'+(i<cur?col:'#e5e5e5')+'"></div>';
    h+='</div>';
  }
  return h+'</div>';
}

function B(l,st,oc){return '<div style="padding:16px 24px;border-radius:10px;font-size:16px;font-weight:600;cursor:pointer;text-align:center;'+st+'" onclick="'+oc+'">'+l+'</div>';}

function varH(pfx,col){
  var vs=PD.variants;
  var sel=pfx==='b'?S.bv:S.ev;
  var h='<div style="text-align:center;margin-bottom:16px">';
  if(PD.image)h+='<img src="'+PD.image+'" style="width:64px;height:64px;border-radius:12px;object-fit:cover;margin-bottom:8px">';
  h+='<div style="font-size:20px;font-weight:700;color:#000">'+esc(PD.title)+'</div>';
  h+='<div style="font-size:15px;color:#000;margin-top:4px">'+vs.length+' colors available</div></div>';
  h+='<div style="font-size:16px;font-weight:600;color:#000;margin-bottom:10px">Select Color:</div>';
  h+='<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px">';
  for(var i=0;i<vs.length;i++){
    var v=vs[i];
    var on=sel===v.name;
    h+='<div style="border-radius:10px;border:2px solid '+(on?col:'#eee')+';overflow:hidden;cursor:pointer;background:'+(on?'#eff6ff':'#fff')+'" onclick="GSP.'+pfx+'V(\''+v.name.replace(/'/g,"\\'")+'\')">';
    if(v.img)h+='<img src="'+v.img+'" style="width:100%;height:72px;object-fit:cover" loading="lazy">';
    h+='<div style="padding:6px;text-align:center;font-size:13px;font-weight:'+(on?'700':'500')+';color:#000">'+esc(v.name)+'</div></div>';
  }
  h+='</div>';
  h+='<div style="text-align:center;margin-top:12px"><div style="font-size:15px;color:#2563eb;cursor:pointer;font-weight:600" onclick="GSP.'+pfx+'Skip()">Skip color selection \u2192</div></div>';
  return h;
}

function ctH(pfx,addr){
  var fk=pfx==='buy'?'bf':'ef';
  var f=S[fk]||{};
  var h='<div style="font-size:24px;font-weight:700;color:#000;margin-bottom:14px">Contact Info</div>';
  h+='<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px">';
  h+='<input style="padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" placeholder="First Name *" value="'+esc(f.fn||'')+'" oninput="GSP.fi(\''+fk+'\',\'fn\',this.value)">';
  h+='<input style="padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" placeholder="Last Name *" value="'+esc(f.ln||'')+'" oninput="GSP.fi(\''+fk+'\',\'ln\',this.value)"></div>';
  h+='<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px">';
  h+='<input style="padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" type="email" placeholder="Email *" value="'+esc(f.em||'')+'" oninput="GSP.fi(\''+fk+'\',\'em\',this.value)">';
  h+='<input style="padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" type="tel" placeholder="Phone *" value="'+esc(f.ph||'')+'" oninput="GSP.fi(\''+fk+'\',\'ph\',this.value)"></div>';
  if(addr){
    h+='<input style="width:100%;padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box;margin-bottom:10px" placeholder="Address *" value="'+esc(f.ad||'')+'" oninput="GSP.fi(\''+fk+'\',\'ad\',this.value)">';
    h+='<div style="display:grid;grid-template-columns:2fr 1fr 1fr;gap:10px">';
    h+='<input style="padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" placeholder="City *" value="'+esc(f.ct||'')+'" oninput="GSP.fi(\''+fk+'\',\'ct\',this.value)">';
    h+='<input style="padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" placeholder="State" value="'+esc(f.st||'')+'" oninput="GSP.fi(\''+fk+'\',\'st\',this.value)">';
    h+='<input style="padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" placeholder="Zip *" value="'+esc(f.zp||'')+'" oninput="GSP.fi(\''+fk+'\',\'zp\',this.value)"></div>';
  }
  return h;
}

function okH(t,s,c){
  return '<div style="text-align:center;padding:36px 0"><div style="width:56px;height:56px;border-radius:50%;margin:0 auto 12px;display:flex;align-items:center;justify-content:center;font-size:26px;color:#fff;background:'+c+'">\u2713</div><h3 style="font-size:26px;font-weight:700;color:#000;margin:0 0 6px">'+esc(t)+'</h3><p style="color:#000;margin:0;font-size:16px">'+esc(s)+'</p><p style="font-size:16px;color:#000;margin-top:14px">Call: <a href="tel:8137875143" style="font-weight:600;color:'+c+'">(813) 787-5143</a> Tampa | <a href="tel:5059343349" style="font-weight:600;color:'+c+'">(505) 934-3349</a> ABQ</p></div>';
}

function selSum(pfx,col){
  var v=pfx==='b'?S.bv:S.ev;
  var vi=null;
  if(v){for(var i=0;i<PD.variants.length;i++){if(PD.variants[i].name===v){vi=PD.variants[i];break;}}}
  var h='<div style="display:flex;align-items:center;gap:10px;padding:12px 16px;border-radius:10px;background:#eff6ff;margin-bottom:16px">';
  var img=vi&&vi.img?vi.img:PD.image;
  if(img)h+='<img src="'+img+'" style="width:52px;height:52px;border-radius:10px;object-fit:cover">';
  h+='<div><div style="font-weight:700;font-size:16px;color:#000">'+esc(PD.title)+'</div>';
  if(v)h+='<div style="font-size:14px;color:'+col+'">'+esc(v)+'</div>';
  h+='</div></div>';
  return h;
}

function rBuy(){
  if(S.bd)return okH('Quote Request Sent!',"We'll respond within 24 hours.",BLUE);
  var h=stH(["Color","Qty & Trim","Ship","Contact"],S.bs,BLUE);
  if(S.bs===0)h+=varH('b',BLUE);
  if(S.bs===1){
    h+=selSum('b',BLUE);
    h+='<div style="font-size:24px;font-weight:700;color:#000;margin-bottom:14px">Quantity & Trim</div>';
    h+='<input style="width:100%;padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box;margin-bottom:14px" placeholder="Sq/ft *" value="'+esc(S.bsq)+'" oninput="upPQ({bsq:this.value})">';
    h+='<div style="font-size:15px;font-weight:600;color:#000;margin-bottom:8px">Trim</div><div style="display:flex;flex-direction:column;gap:6px">';
    for(var i=0;i<TRIMS.length;i++){
      var tr=TRIMS[i];
      if(tr==='None'){var non=S.btr.indexOf('None')>=0;h+='<div style="display:flex;align-items:center;justify-content:center;padding:12px 14px;border-radius:10px;border:1px solid '+(non?BLUE:'#eee')+';background:'+(non?'#eff6ff':'#fff')+';cursor:pointer;font-size:14px;font-weight:'+(non?'600':'500')+';color:'+(non?'#1d4ed8':'#000')+'" onclick="GSP.bTrNone()">None</div>';}else{var qty=(S.btrQty&&S.btrQty[tr])||0;var on=qty>0;
      h+='<div style="display:flex;align-items:center;justify-content:space-between;padding:8px 14px;border-radius:10px;border:1px solid '+(on?BLUE:'#eee')+';background:'+(on?'#eff6ff':'#fff')+'"><div style="font-size:14px;font-weight:'+(on?'600':'500')+';color:'+(on?'#1d4ed8':'#000')+'">'+esc(tr)+'</div><div style="display:flex;align-items:center;gap:8px"><div onclick="GSP.bTrM(\''+esc(tr)+'\')" style="width:32px;height:32px;border-radius:50%;background:'+(on?'#dbeafe':'#f3f4f6')+';display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:18px;font-weight:700;color:'+(on?BLUE:'#999')+';user-select:none">\u2212</div><div style="min-width:24px;text-align:center;font-size:15px;font-weight:700;color:#000">'+qty+'</div><div onclick="GSP.bTrP(\''+esc(tr)+'\')" style="width:32px;height:32px;border-radius:50%;background:#dbeafe;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:18px;font-weight:700;color:'+BLUE+';user-select:none">+</div></div></div>';}}
    h+='</div>';
    if(S.btr.length&&S.btr.indexOf('None')<0)h+='<input style="width:100%;margin-top:10px;padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" placeholder="Trim details" value="'+esc(S.btq)+'" oninput="upPQ({btq:this.value})">';
    // validation at click time
    h+='<div style="margin-top:16px;padding:14px;border-radius:10px;border:2px dashed #bfdbfe;display:flex;align-items:center;justify-content:space-between">';
    h+='<div><div style="font-weight:700;font-size:16px;color:'+BLUE+'">Need installation?</div><div style="font-size:13px;color:#000">Selections carry over.</div></div>';
    h+=B('Add \u2192','background:'+BLUE+';color:#fff;font-size:14px;padding:10px 16px','GSP.bUp()')+'</div>';
    h+='<div style="display:flex;gap:8px;margin-top:16px">'+B('\u2190 Back','background:#fff;color:#000;border:1px solid #d1d5db','upP({bs:0})')+B('Shipping \u2192','flex:1;background:'+BLUE+';color:#fff','GSP.bToShip()')+'</div>';
  }
  if(S.bs===2){
    h+=selSum('b',BLUE);
    h+='<div style="font-size:24px;font-weight:700;color:#000;margin-bottom:16px">Shipping</div><div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">';
    h+='<div style="padding:22px;border-radius:10px;border:2px solid '+(S.bsh==='pickup'?BLUE:'#eee')+';text-align:center;cursor:pointer;background:'+(S.bsh==='pickup'?'#eff6ff':'#fff')+'" onclick="upP({bsh:\'pickup\'})"><div style="font-size:24px;margin-bottom:4px">\u{1F3EA}</div><div style="font-weight:700;font-size:16px;color:#000">Free Pick Up</div></div>';
    h+='<div style="padding:22px;border-radius:10px;border:2px solid '+(S.bsh==='ship'?BLUE:'#eee')+';text-align:center;cursor:pointer;background:'+(S.bsh==='ship'?'#eff6ff':'#fff')+'" onclick="upP({bsh:\'ship\'})"><div style="font-size:24px;margin-bottom:4px">\u{1F69A}</div><div style="font-weight:700;font-size:16px;color:#000">Ship to Me</div></div></div>';
    if(S.bsh==='pickup'){
      h+='<select style="width:100%;margin-top:12px;padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;background:#fff;box-sizing:border-box" onchange="upP({brd:this.value})"><option value="">Choose location...</option>';
      for(var i=0;i<RDCS.length;i++){h+='<option'+(S.brd===RDCS[i]?' selected':'')+'>'+esc(RDCS[i])+'</option>';}
      h+='</select>';
    }
    if(S.bsh==='ship')h+='<input style="width:100%;margin-top:12px;padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" placeholder="Shipping address" value="'+esc(S.bad)+'" oninput="upPQ({bad:this.value})">';
    h+='<div style="display:flex;gap:8px;margin-top:16px">'+B('\u2190 Back','background:#fff;color:#000;border:1px solid #d1d5db','upP({bs:1})')+B('Contact \u2192','flex:1;background:'+BLUE+';color:#fff','upP({bs:3})')+'</div>';
  }
  if(S.bs===3){
    h+=selSum('b',BLUE);
    h+='<div style="padding:12px;background:#f9fafb;border-radius:10px;font-size:16px;color:#000;margin-bottom:14px">';
    h+='<div><b>Qty:</b> '+esc(S.bsq)+' sqft</div>';
    if(S.btr.length&&S.btr[0]!=='None'){var _bt=[];for(var _i=0;_i<S.btr.length;_i++){var _tn=S.btr[_i];var _tq=(S.btrQty&&S.btrQty[_tn])||1;_bt.push(_tn+' x'+_tq);}h+='<div><b>Trim:</b> '+esc(_bt.join(', '))+'</div>';}
    h+='<div><b>Ship:</b> '+(S.bsh==='pickup'?esc(S.brd||'Pick Up'):'Ship')+'</div></div>';
    h+=ctH('buy',false);
    h+='<div style="display:flex;gap:8px;margin-top:16px">'+B('\u2190 Back','background:#fff;color:#000;border:1px solid #d1d5db','upP({bs:2})')+B('Send Quote \u2192','flex:1;background:'+BLUE+';color:#fff;font-weight:700','GSP.submitBuy()')+'</div>';
  }
  return h;
}

function rEst(){
  if(S.ed)return okH('Estimate Sent!',"We'll contact you within 24 hours.",GREEN);
  var h=stH(["Color","Qty & Trim","Space","Contact"],S.es,GREEN);
  if(S.es===0)h+=varH('e',GREEN);
  if(S.es===1){
    h+=selSum('e',GREEN);
    h+='<div style="font-size:24px;font-weight:700;color:#000;margin-bottom:14px">Quantity & Trim</div>';
    h+='<input style="width:100%;padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box;margin-bottom:14px" placeholder="Sq/ft *" value="'+esc(S.esq)+'" oninput="upPQ({esq:this.value})">';
    h+='<div style="font-size:15px;font-weight:600;color:#000;margin-bottom:8px">Trim</div><div style="display:flex;flex-direction:column;gap:6px">';
    for(var i=0;i<TRIMS.length;i++){
      var tr=TRIMS[i];
      if(tr==='None'){var non=S.etr.indexOf('None')>=0;h+='<div style="display:flex;align-items:center;justify-content:center;padding:12px 14px;border-radius:10px;border:1px solid '+(non?GREEN:'#eee')+';background:'+(non?'#f0f7f5':'#fff')+';cursor:pointer;font-size:14px;font-weight:'+(non?'600':'500')+';color:'+(non?GREEN:'#000')+'" onclick="GSP.eTrNone()">None</div>';}else{var qty=(S.etrQty&&S.etrQty[tr])||0;var on=qty>0;
      h+='<div style="display:flex;align-items:center;justify-content:space-between;padding:8px 14px;border-radius:10px;border:1px solid '+(on?GREEN:'#eee')+';background:'+(on?'#f0f7f5':'#fff')+'"><div style="font-size:14px;font-weight:'+(on?'600':'500')+';color:'+(on?GREEN:'#000')+'">'+esc(tr)+'</div><div style="display:flex;align-items:center;gap:8px"><div onclick="GSP.eTrM(\''+esc(tr)+'\')" style="width:32px;height:32px;border-radius:50%;background:'+(on?'#d1fae5':'#f3f4f6')+';display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:18px;font-weight:700;color:'+(on?GREEN:'#999')+';user-select:none">\u2212</div><div style="min-width:24px;text-align:center;font-size:15px;font-weight:700;color:#000">'+qty+'</div><div onclick="GSP.eTrP(\''+esc(tr)+'\')" style="width:32px;height:32px;border-radius:50%;background:#d1fae5;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:18px;font-weight:700;color:'+GREEN+';user-select:none">+</div></div></div>';}}
    h+='</div>';
    if(S.etr.length&&S.etr.indexOf('None')<0)h+='<input style="width:100%;margin-top:10px;padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" placeholder="Trim details" value="'+esc(S.etq)+'" oninput="upPQ({etq:this.value})">';
    // validation at click time
    h+='<div style="display:flex;gap:8px;margin-top:16px">'+B('\u2190 Back','background:#fff;color:#000;border:1px solid #d1d5db','upP({es:0})')+B('Space & Services \u2192','flex:1;background:'+GREEN+';color:#fff','GSP.eToSpace()')+'</div>';
  }
  if(S.es===2){
    h+=selSum('e',GREEN);
    h+='<div style="font-size:24px;font-weight:700;color:#000;margin-bottom:14px">Your Space</div>';
    h+='<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px">';
    h+='<input style="width:100%;padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" placeholder="Rooms" value="'+esc(S.err)+'" oninput="upPQ({err:this.value})">';
    h+='<input style="width:100%;padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box" placeholder="Current floor" value="'+esc(S.ecf)+'" oninput="upPQ({ecf:this.value})"></div>';
    h+='<div style="font-size:20px;font-weight:700;color:#000;margin-bottom:10px">Services</div>';
    h+='<div style="display:grid;grid-template-columns:1fr 1fr;gap:6px">';
    for(var i=0;i<SVCS.length;i++){
      var sv=SVCS[i];
      var on=S.esv.indexOf(sv)>=0;
      h+='<div style="padding:14px;border-radius:10px;border:2px solid '+(on?GREEN:'#eee')+';font-size:15px;color:'+(on?GREEN:'#000')+';background:'+(on?'#f0f7f5':'#fff')+';cursor:pointer" onclick="GSP.eSv(\''+esc(sv)+'\')">'+(on?'\u2713 ':'')+esc(sv)+'</div>';
    }
    h+='</div>';
    h+='<textarea style="width:100%;margin-top:12px;padding:14px 16px;border:1px solid #d1d5db;border-radius:10px;font-size:16px;box-sizing:border-box;resize:none;min-height:90px" placeholder="Notes..." oninput="upPQ({edd:this.value})">'+esc(S.edd)+'</textarea>';
    h+='<div style="display:flex;gap:8px;margin-top:16px">'+B('\u2190 Back','background:#fff;color:#000;border:1px solid #d1d5db','upP({es:1})')+B('Contact \u2192','flex:1;background:'+GREEN+';color:#fff','upP({es:3})')+'</div>';
  }
  if(S.es===3){
    h+=selSum('e',GREEN);
    h+='<div style="padding:12px;background:#f9fafb;border-radius:10px;font-size:16px;color:#000;margin-bottom:14px">';
    h+='<div><b>Qty:</b> '+esc(S.esq)+' sqft</div>';
    if(S.etr.length&&S.etr[0]!=='None'){var _et=[];for(var _i=0;_i<S.etr.length;_i++){var _tn=S.etr[_i];var _tq=(S.etrQty&&S.etrQty[_tn])||1;_et.push(_tn+' x'+_tq);}h+='<div><b>Trim:</b> '+esc(_et.join(', '))+'</div>';}
    if(S.err)h+='<div><b>Rooms:</b> '+esc(S.err)+'</div>';
    if(S.esv.length)h+='<div><b>Services:</b> '+esc(S.esv.join(', '))+'</div>';
    h+='</div>';
    h+=ctH('est',true);
    h+='<div style="display:flex;gap:8px;margin-top:16px">'+B('\u2190 Back','background:#fff;color:#000;border:1px solid #d1d5db','upP({es:2})')+B('Request Estimate \u2192','flex:1;background:'+GREEN+';color:#fff;font-weight:700','GSP.submitEst()')+'</div>';
  }
  return h;
}

function RP(){
  var a=document.getElementById('gsp-buy');
  var b=document.getElementById('gsp-est');
  if(!a)return;
  a.innerHTML=rBuy();
  b.innerHTML=rEst();
  a.style.display=S.tab==='buy'?'block':'none';
  b.style.display=S.tab==='estimate'?'block':'none';
  var btns=document.querySelectorAll('[data-pgt]');
  for(var i=0;i<btns.length;i++){
    var el=btns[i];
    var t=el.getAttribute('data-pgt');
    var on=S.tab===t;
    var col=t==='buy'?BLUE:GREEN;
    el.style.background=on?col:'#e5e7eb';
    el.style.color=on?'#fff':'#000';
    el.style.boxShadow=on?'0 3px 10px rgba(0,0,0,.15)':'none';
  }
}

window.GSP={
  tab:function(t){upP({tab:t});},
  fi:function(p,k,v){S[p][k]=v;},
  bV:function(n){upP({bv:n,bs:1});},
  bSkip:function(){upP({bv:null,bs:1});},
  bTrP:function(t){var q=S.btrQty;q[t]=(q[t]||0)+1;var tr=[];for(var k in q)if(q[k]>0)tr.push(k);var ni=tr.indexOf('None');if(ni>=0)tr.splice(ni,1);upP({btr:tr,btrQty:q});},
  bTrM:function(t){var q=S.btrQty;if(!q[t])return;q[t]=Math.max(0,q[t]-1);var tr=[];for(var k in q)if(q[k]>0)tr.push(k);upP({btr:tr,btrQty:q});},
  bTrNone:function(){var on=S.btr.indexOf('None')>=0;if(on){upP({btr:[],btrQty:{}});}else{upP({btr:['None'],btrQty:{}});}},
  bUp:function(){if(!S.bsq||!S.btr.length){alert('Please enter sq/ft and select trim.');return;}upP({tab:'estimate',ev:S.bv,esq:S.bsq,etr:S.btr.slice(),etq:S.btq,es:2});},
  bToShip:function(){if(!S.bsq){alert('Please enter sq/ft.');return;}if(!S.btr.length){alert('Please select trim.');return;}upP({bs:2});},
  eV:function(n){upP({ev:n,es:1});},
  eSkip:function(){upP({ev:null,es:1});},
  eTrP:function(t){var q=S.etrQty;q[t]=(q[t]||0)+1;var tr=[];for(var k in q)if(q[k]>0)tr.push(k);var ni=tr.indexOf('None');if(ni>=0)tr.splice(ni,1);upP({etr:tr,etrQty:q});},
  eTrM:function(t){var q=S.etrQty;if(!q[t])return;q[t]=Math.max(0,q[t]-1);var tr=[];for(var k in q)if(q[k]>0)tr.push(k);upP({etr:tr,etrQty:q});},
  eTrNone:function(){var on=S.etr.indexOf('None')>=0;if(on){upP({etr:[],etrQty:{}});}else{upP({etr:['None'],etrQty:{}});}},
  eSv:function(sv){var a=S.esv.slice();var i=a.indexOf(sv);if(i>=0)a.splice(i,1);else a.push(sv);upP({esv:a});},
  eToSpace:function(){if(!S.esq){alert('Please enter sq/ft.');return;}if(!S.etr.length){alert('Please select trim.');return;}upP({es:2});},
  submitBuy:function(){
    var f=S.bf;
    if(!f.fn||!f.ln||!f.em||!f.ph){alert('Please fill in all required fields.');return;}
    var p=new URLSearchParams();
    p.set('tab','buy');
    p.set('product',PD.title);
    if(S.bv)p.set('color',S.bv);
    p.set('floor',PD.type||'');
    p.set('sqft',S.bsq);
    if(S.btr.length){var _tp=[];for(var _i=0;_i<S.btr.length;_i++){var _tn=S.btr[_i];var _tq=(S.btrQty&&S.btrQty[_tn])||1;_tp.push(_tn+' x'+_tq);}p.set('trim',_tp.join(','));}
    if(S.btq)p.set('trimdetail',S.btq);
    p.set('ship',S.bsh);
    if(S.brd)p.set('rdc',S.brd);
    if(S.bad)p.set('addr',S.bad);
    p.set('fn',f.fn);p.set('ln',f.ln);p.set('em',f.em);p.set('ph',f.ph);
    window.location.href='/pages/contact?'+p.toString();
  },
  submitEst:function(){
    var f=S.ef;
    if(!f.fn||!f.ln||!f.em||!f.ph){alert('Please fill in all required fields.');return;}
    var p=new URLSearchParams();
    p.set('tab','estimate');
    p.set('product',PD.title);
    if(S.ev)p.set('color',S.ev);
    p.set('floor',PD.type||'');
    p.set('sqft',S.esq);
    if(S.etr.length){var _tp=[];for(var _i=0;_i<S.etr.length;_i++){var _tn=S.etr[_i];var _tq=(S.etrQty&&S.etrQty[_tn])||1;_tp.push(_tn+' x'+_tq);}p.set('trim',_tp.join(','));}
    if(S.etq)p.set('trimdetail',S.etq);
    if(S.err)p.set('rooms',S.err);
    if(S.ecf)p.set('curfloor',S.ecf);
    if(S.esv.length)p.set('services',S.esv.join(','));
    if(S.edd)p.set('notes',S.edd);
    p.set('fn',f.fn);p.set('ln',f.ln);p.set('em',f.em);p.set('ph',f.ph);
    if(f.ad)p.set('addr',f.ad);if(f.ct)p.set('city',f.ct);if(f.st)p.set('state',f.st);if(f.zp)p.set('zip',f.zp);
    window.location.href='/pages/contact?'+p.toString();
  }
};
window.upP=upP;
window.upPQ=upPQ;

RP();
})();